import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getAMLSCommonUnifiedAlerts,
  putAMLSCommonAlertPartyUpdate
} from '../../../../redux/actions/common';
import Result from './Result';
import { fetchTypologiesActions } from '../../../../redux/actions/common';

function mapStateToProps(state) {
  const { amlsCommon = {} } = state;
  const { unifiedAlerts = {} } = amlsCommon;
  const { isLoading, data, error } = unifiedAlerts;
  return {
    isLoading,
    error,
    scenarioResults: data,
    authentication: state.authentication,
    trmActions: state.amlsCommon.commonTypologyAction
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resultAPIActions: bindActionCreators(
      {
        getAMLSCommonUnifiedAlerts,
        putAMLSCommonAlertPartyUpdate,
        fetchTypologiesActions
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Result);
